<template>
  <div class="app-event-creation">
    <LegalActionBar
      :cur-action="curAction"
      @changeAction="curAction = $event"
      :loaded="loaded"
    />
    <AlertBar></AlertBar>
    <BannerTitle
      :title="`Legal Review of ${CURRENT_EVENT_OBJECT.name}`"
      :loading="!loaded"
    />
    <template v-if="loaded">
      <LegalSummaryForm />
    </template>
  </div>
</template>

<script>
import AlertBar from '@/components/AlertBar.vue';
import BannerTitle from '@/components/BannerTitle.vue';
import LegalSummaryForm from '@/components/Legal/LegalSummaryForm.vue';
import LegalActionBar from '@/components/Legal/LegalActionBar.vue';
import ThemeSwitcher from '@/utility/ThemeSwitcher';
import { mapState } from 'vuex';

export default {
  name: 'LegalSummary',
  components: {
    AlertBar,
    BannerTitle,
    LegalSummaryForm,
    LegalActionBar
  },
  data() {
    return {
      loaded: false,
      curAction: null
    };
  },
  computed: {
    ...mapState('EVENT_MANAGER_STORE', ['CURRENT_EVENT_OBJECT']),
    ...mapState('LEGAL_STORE', ['CURRENT_LEGAL_OBJECT']),
    brandWatcher() {
      return this.CURRENT_EVENT_OBJECT && this.CURRENT_EVENT_OBJECT.brand
        ? this.CURRENT_EVENT_OBJECT.brand
        : 'T-Mobile';
    }
  },
  watch: {
    brandWatcher: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.changeTheme(newVal);
        }
      }
    }
  },
  async created() {
    this.loaded = false;
    let evtId = this.$route.params.id;
    await this.$store.dispatch('EVENT_MANAGER_STORE/LOAD_EVENT', evtId);
    await this.$store.dispatch('EVENT_MANAGER_STORE/FETCH_BITLY_LINK', evtId);
    await this.$store.dispatch('LEGAL_STORE/FETCH_LEGAL', evtId);
    this.loaded = true;
  },
  methods: {
    showTranslationButton() {
      return this.CURRENT_EVENT_OBJECT.eventLanguage === 'bi';
    },
    changeTheme(brand) {
      ThemeSwitcher.ChangeTheme(this, brand);
    }
  }
};
</script>

<style scoped>
.loading-row {
  padding: 32px;
  text-align: center;
}
</style>
